import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, interval, lastValueFrom } from 'rxjs';
import { estadoTiempo } from 'src/app/shared/const/estado-tiempo.enum';
import { sexo } from 'src/app/shared/const/sexo.enum';
import { LocalStorageService } from 'src/app/shared/storage';
import Swal from 'sweetalert2';
import { ReadFileService } from '../../../services/read-file.service';

@Component({
    selector: 'app-pantalla-giro',
    templateUrl: './pantalla-giro.component.html',
    styleUrls: ['./pantalla-giro.component.scss']
})
export class PantallaGiroComponent implements OnInit, OnDestroy {

    public marcajes: any[] = [];
    public registros: any[] = [];

    subscription: Subscription;
    public porcentaje = 0;
    public tipoClasificacion = '';
    public tipoDisciplina = '';
    public marcajesUnicos: any[] = [];
    public cantidadPorTabla = 0;
    public ordenPantalla = null;
    public numerosDisponibles = [];
    public numerosRandom = [];
    public segundos = 0;
    public cambiarCat = '';
    public desafiosPremiacion = [];
    public prefixPathResultados = '';
    private resultadosSubscription: Subscription;
    public prefixPathRegistros = '';

    constructor(
        private readFileService: ReadFileService,
        private localStorageAs: LocalStorageService,
        private _router: Router,
    ) { }

    get DNF(): string {
        return estadoTiempo.DNF;
    };

    get DNS(): string {
        return estadoTiempo.DNS;
    }

    get DPP(): string {
        return estadoTiempo.DPP;
    }

    ngOnInit(): void {
        if (localStorage.getItem('path')) {
            this.getMarcajes();
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar la ruta del archivo',
                'error'
            );
        }

        if (localStorage.getItem('tipo_clasificacion')) {
            this.tipoClasificacion = localStorage.getItem('tipo_clasificacion');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar el tipo de clasificación',
                'error'
            );
        }

        if (localStorage.getItem('tipo_disciplina')) {
            this.tipoDisciplina = localStorage.getItem('tipo_disciplina');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar el tipo de disciplina',
                'error'
            );
        }

        if (localStorage.getItem('cantidad_tabla')) {
            this.cantidadPorTabla = Number(localStorage.getItem('cantidad_tabla'));
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar la cantidad por tabla',
                'error'
            );
        }

        if (localStorage.getItem('orden_pantalla')) {
            this.ordenPantalla = localStorage.getItem('orden_pantalla');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar el orden de deportistas',
                'error'
            );
        }

        if (localStorage.getItem('cambiar_cat')) {
            this.cambiarCat = localStorage.getItem('cambiar_cat');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar el campo cambiar categoría',
                'error'
            );
        }

        this.localStorageAs.watch('desafios_premiacion').subscribe(desafiosPremiacionStorage => {
            if (desafiosPremiacionStorage !== null) {
                this.desafiosPremiacion = JSON.parse(desafiosPremiacionStorage);

            }
        });
    }

    getMarcajes() {
        const source = interval(1000);
        this.subscription = source.subscribe(async val => {
            this.segundos = val;

            this.porcentaje = (val % 2) * 50;
            if (val % 2 === 0) {

                const filesResultados = [];
                const filesRegistros = [];
                const resultados = await lastValueFrom(this.readFileService.getDirectory(localStorage.getItem('path')));
                const respuestaResultados = resultados.match(/\b\w*resultados\w*\b/g);
                respuestaResultados.forEach((file) => {
                    filesResultados.push(Number((file
                        .replace(/"/gi, '')
                        .replace(/lOG_resultados/gi, '')
                        .split('.txt')[0]))
                    );
                });
                this.prefixPathResultados = String(Math.max(...filesResultados));

                const respuestaRegistros = resultados.match(/\b\w*registros\w*\b/g);
                respuestaRegistros.forEach((file) => {
                    filesRegistros.push(Number((file
                        .replace(/"/gi, '')
                        .replace(/lOG_registros/gi, '')
                        .split('.txt')[0]))
                    );
                });

                this.prefixPathRegistros = String(Math.max(...filesRegistros));

                this.getResultados();
                this.getRegistros();



            }
        });

    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

        if (this.resultadosSubscription) {
            this.resultadosSubscription.unsubscribe();
        }
    }


    async getResultados() {
        const resultados = await lastValueFrom(this.readFileService.getFile(`${localStorage.getItem('path')}/lOG_resultados${this.prefixPathResultados}.txt`));
        this.procesarResultados(resultados)
    }

    async getRegistros() {
        const resultados = await lastValueFrom(this.readFileService.getFile(`${localStorage.getItem('path')}/lOG_registros${this.prefixPathRegistros}.txt`));
        this.procesarRegistros(resultados)
    }

    procesarRegistros(resultados: string) {
        if (resultados === undefined) { return; }

        const marcajesCopy = [];

        resultados.toString().split('\n').forEach((linea, index) => {
            if (index > 0 && linea.length > 1) {
                if (linea.split('\t')[0] !== '') {


                    if (this.buscarDor(linea.split('\t')[0]).estadoTiempo !== this.DNS) {
                        marcajesCopy.push({
                            tag: linea.split('\t')[0],
                            fechaPartida: linea.split('\t')[1],
                            horaMayor: this.encontrarHoraMayor(linea.split('\t').slice(2, 18)),
                            giros: this.buscarDor(linea.split('\t')[0]).giros === undefined ? 0 : this.buscarDor(linea.split('\t')[0]).giros
                        });
                    }




                }
            }
        });

        this.registros = marcajesCopy;

        this.registros.sort(this.compararPorHoraMayor);

        const cantidadGiros = this.primerasOcurrencias();

        switch (cantidadGiros.length) {
            case 0:

                this.numerosRandom = [
                    undefined
                ];


                break;
            case 1:
                if (
                    this.numerosRandom[0] === undefined
                ) {
                    this.numerosRandom = [
                        this.obtenerNumeroRandom()
                    ];
                }

                break;
            case 2:
                if (
                    this.numerosRandom[0] === undefined &&
                    this.numerosRandom[1] === undefined
                ) {
                    this.numerosRandom = [
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom()
                    ];
                }
                break;
            case 3:
                if (
                    this.numerosRandom[0] === undefined &&
                    this.numerosRandom[1] === undefined &&
                    this.numerosRandom[2] === undefined
                ) {
                    this.numerosRandom = [
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom()
                    ];
                }

                break;
            case 4:
                if (
                    this.numerosRandom[0] === undefined &&
                    this.numerosRandom[1] === undefined &&
                    this.numerosRandom[2] === undefined &&
                    this.numerosRandom[3] === undefined
                ) {
                    this.numerosRandom = [
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom()
                    ];
                }

                break;
            default:
                if (
                    this.numerosRandom[0] === undefined &&
                    this.numerosRandom[1] === undefined &&
                    this.numerosRandom[2] === undefined &&
                    this.numerosRandom[3] === undefined
                ) {
                    this.numerosRandom = [
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom()
                    ];
                }
                if (this.segundos % 10 === 0) {
                    this.numerosRandom = [
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom(),
                        this.obtenerNumeroRandom()
                    ];
                }
                break;
        }

    }

    compararPorHoraMayor(a, b) {
        const horaMayorA = a.horaMayor;
        const horaMayorB = b.horaMayor;

        if (horaMayorA < horaMayorB) {
            return 1; // Invierte el orden para mayor a menor
        }
        if (horaMayorA > horaMayorB) {
            return -1; // Invierte el orden para mayor a menor
        }
        return 0;
    }

    procesarResultados(resultados: string) {
        if (resultados === undefined) { return; }

        let marcajesCopy = [];
        const lugarCategorias: any = {};
        const lugarGiros: any = {};
        const lugarDesafio: any = {};
        resultados.toString().split('\n').forEach((linea, index) => {
            if (index > 0 && linea.length > 1) {
                if (linea.split('\t')[0] !== '') {

                    const giros = linea.split('\t').slice(5, 20);
                    const girosCompletados = giros.filter((giro) => giro !== '').length;

                    marcajesCopy.push({
                        dor: linea.split('\t')[0],
                        nombre: linea.split('\t')[3],
                        apellido: linea.split('\t')[2],
                        tiempo: linea.split('\t')[22],
                        categoria: linea.split('\t')[4].split(' ').join('_'),
                        giros: Number(linea.split('\t')[42]),
                        girosCompletados,
                        estadoTiempo: `${linea.split('\t')[23]}`,
                        desafio: `${linea.split('\t')[40]}`,
                        sexo: (linea.split('\t')[39]).toString().toLowerCase(),
                        tag: linea.split('\t')[1],

                    });



                }
            }
        });


        marcajesCopy.forEach((marcajeCopy) => {
            if (!lugarCategorias[marcajeCopy.categoria]) {
                lugarCategorias[marcajeCopy.categoria] = [];
            }

            lugarCategorias[marcajeCopy.categoria] = lugarCategorias[marcajeCopy.categoria].concat([{
                dor: marcajeCopy.dor,
                nombre: marcajeCopy.nombre,
                apellido: marcajeCopy.apellido,
                tiempo: marcajeCopy.tiempo,
                categoria: marcajeCopy.categoria,
                giros: marcajeCopy.giros,
                girosCompletados: marcajeCopy.girosCompletados,
                estadoTiempo: `${marcajeCopy.estadoTiempo}`,
                team: `${marcajeCopy.team}`,
                desafio: `${marcajeCopy.desafio}`,
                sexo: marcajeCopy.sexo.toLowerCase(),
            }]);


            if (!lugarGiros[marcajeCopy.giros]) {
                lugarGiros[marcajeCopy.giros] = [];
            }

            lugarGiros[marcajeCopy.giros] = lugarGiros[marcajeCopy.giros].concat([{
                dor: marcajeCopy.dor,
                nombre: marcajeCopy.nombre,
                apellido: marcajeCopy.apellido,
                tiempo: marcajeCopy.tiempo,
                categoria: marcajeCopy.categoria,
                giros: marcajeCopy.giros,
                girosCompletados: marcajeCopy.girosCompletados,
                estadoTiempo: `${marcajeCopy.estadoTiempo}`,
                desafio: `${marcajeCopy.desafio}`,
                team: `${marcajeCopy.team}`,
                sexo: marcajeCopy.sexo.toLowerCase(),
            }]);

            if (!lugarDesafio[marcajeCopy.desafio]) {
                lugarDesafio[marcajeCopy.desafio] = [];
            }

            lugarDesafio[marcajeCopy.desafio] = lugarDesafio[marcajeCopy.desafio].concat([{
                dor: marcajeCopy.dor,
                nombre: marcajeCopy.nombre,
                apellido: marcajeCopy.apellido,
                tiempo: marcajeCopy.tiempo,
                categoria: marcajeCopy.categoria,
                giros: marcajeCopy.giros,
                girosCompletados: marcajeCopy.girosCompletados,
                estadoTiempo: `${marcajeCopy.estadoTiempo}`,
                team: `${marcajeCopy.team}`,
                desafio: `${marcajeCopy.desafio}`,
                sexo: marcajeCopy.sexo.toLowerCase(),
            }]);
        });

        //GUARDAR DESAFIOS EN LOCALSTORAGE
        localStorage.setItem('desafios', JSON.stringify(Object.keys(lugarDesafio)));

        this.marcajes = marcajesCopy;
        // ORDEN CLASIFICACION POR GIRO

        (Object.keys(lugarGiros) as (keyof typeof lugarGiros)[]).forEach((key, index) => {
            lugarGiros[key] = lugarGiros[key].sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);
        });

        this.marcajes.forEach((marcajeFor) => {
            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_giro = index + 1;
                }

            });

            //MASCULINO
            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.sexo === sexo.MASCULINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_giro_sexo = index + 1;
                }
            });

            //FEMENINO
            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.sexo === sexo.FEMENINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_giro_sexo = index + 1;
                }
            });

            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    switch (marcajeCategoria.estadoTiempo) {
                        case this.DNF:
                            marcajeFor.posicion_giro = this.DNF;
                            marcajeFor.posicion_giro_sexo = this.DNF;
                            break;
                        case this.DNS:
                            marcajeFor.posicion_giro = this.DNS;
                            marcajeFor.posicion_giro_sexo = this.DNS;
                            break;
                        case this.DPP:
                            marcajeFor.posicion_giro = this.DPP;
                            marcajeFor.posicion_giro_sexo = this.DPP;
                            break;
                        default:
                            if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                marcajeFor.posicion_giro = 'EN RUTA';
                                marcajeFor.posicion_giro_sexo = 'EN RUTA';
                            }
                            break;

                    }



                }

            });
        });

        // ORDEN CLASIFICACION POR DESAFIO


        (Object.keys(lugarDesafio) as (keyof typeof lugarDesafio)[]).forEach((key, index) => {
            lugarDesafio[key] = lugarDesafio[key].sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);
        });

        this.marcajes.forEach((marcajeFor) => {
            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_desafio = index + 1;
                }

            });

            //MASCULINO
            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.sexo === sexo.MASCULINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_desafio_sexo = index + 1;
                }

            });

            //FEMENINO
            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.sexo === sexo.FEMENINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_desafio_sexo = index + 1;
                }

            });

            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    switch (marcajeCategoria.estadoTiempo) {
                        case this.DNF:
                            marcajeFor.posicion_desafio = this.DNF;
                            marcajeFor.posicion_desafio_sexo = this.DNF;
                            break;
                        case this.DNS:
                            marcajeFor.posicion_desafio = this.DNS;
                            marcajeFor.posicion_desafio_sexo = this.DNS;
                            break;
                        case this.DPP:
                            marcajeFor.posicion_desafio = this.DPP;
                            marcajeFor.posicion_desafio_sexo = this.DPP;
                            break;
                        default:
                            if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                marcajeFor.posicion_desafio = 'EN RUTA';
                                marcajeFor.posicion_desafio_sexo = 'EN RUTA';
                            }
                            break;

                    }

                }

            });
        });


        (Object.keys(lugarCategorias) as (keyof typeof lugarCategorias)[]).forEach((key, index) => {
            lugarCategorias[key] = lugarCategorias[key].sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);
        });
        switch (this.tipoDisciplina) {
            case 'Trail':
                this.marcajes.forEach((marcajeFor) => {

                    if (this.tipoClasificacion === 'Por Giro' &&

                        (marcajeFor.posicion_giro_sexo > 0 &&
                            marcajeFor.posicion_giro_sexo <= this.buscarDesafioPremiacion(marcajeFor.desafio))) {
                        marcajeFor.posicion_categoria = 'PREMIADO/A EN GENERAL';
                    }
                    if (this.tipoClasificacion === 'Por Desafio' && (marcajeFor.posicion_desafio_sexo > 0 && marcajeFor.posicion_desafio_sexo <= this.buscarDesafioPremiacion(marcajeFor.desafio))) {
                        marcajeFor.posicion_categoria = 'PREMIADO/A EN GENERAL';

                    }


                });


                this.marcajes.filter((marcajeFiltro) => !(this.tipoClasificacion === 'Por Giro' && (marcajeFiltro.posicion_desafio_sexo > 0 && marcajeFiltro.posicion_desafio_sexo <= this.buscarDesafioPremiacion(marcajeFiltro.desafio))) &&
                    !(this.tipoClasificacion === 'Por Desafio' && (marcajeFiltro.posicion_desafio_sexo > 0 && marcajeFiltro.posicion_desafio_sexo <= this.buscarDesafioPremiacion(marcajeFiltro.desafio)))
                ).forEach((marcajeFor) => {
                    lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => !this.estaPremiadoGeneral(filtro.dor) && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            marcajeFor.posicion_categoria = index + 1;
                        }

                    });

                    lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            switch (marcajeCategoria.estadoTiempo) {
                                case this.DNF:
                                    marcajeFor.posicion_categoria = this.DNF;
                                    break;
                                case this.DNS:
                                    marcajeFor.posicion_categoria = this.DNS;
                                    break;
                                case this.DPP:
                                    marcajeFor.posicion_categoria = this.DPP;
                                    break;
                                default:
                                    if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                        marcajeFor.posicion_categoria = 'EN RUTA';
                                    }
                                    break;

                            }

                        }

                    });
                });
                break;

            case 'Ciclismo':
                this.marcajes.forEach((marcajeFor) => {
                    lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            marcajeFor.posicion_categoria = index + 1;
                        }

                    });

                    lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            switch (marcajeCategoria.estadoTiempo) {
                                case this.DNF:
                                    marcajeFor.posicion_categoria = this.DNF;
                                    break;
                                case this.DNS:
                                    marcajeFor.posicion_categoria = this.DNS;
                                    break;
                                case this.DPP:
                                    marcajeFor.posicion_categoria = this.DPP;
                                    break;
                                default:
                                    if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                        marcajeFor.posicion_categoria = 'EN RUTA';
                                    }
                                    break;

                            }

                        }

                    });
                });
                break;
            case 'Motociclismo':
                this.marcajes.forEach((marcajeFor) => {
                    lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            marcajeFor.posicion_categoria = index + 1;
                        }

                    });

                    lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            switch (marcajeCategoria.estadoTiempo) {
                                case this.DNF:
                                    marcajeFor.posicion_categoria = this.DNF;
                                    break;
                                case this.DNS:
                                    marcajeFor.posicion_categoria = this.DNS;
                                    break;
                                case this.DPP:
                                    marcajeFor.posicion_categoria = this.DPP;
                                    break;
                                default:
                                    if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                        marcajeFor.posicion_categoria = 'EN RUTA';
                                    }
                                    break;

                            }

                        }

                    });
                });
                break;
        }
        this.agruparPorGiro();
    }

    buscarDesafioPremiacion(desafio) {
        return this.desafiosPremiacion[desafio] === undefined ? 0 : this.desafiosPremiacion[desafio];
    }

    formatearNombre(nombre: number, replaceFirst: boolean) {
        if (nombre === undefined) { return ''; }
        let nombreReturn = `${nombre}`.split('_').join(' ');
        if (replaceFirst) {

            const partes = nombreReturn.split(" ");
            // Elimina la primera parte (el número)
            partes.shift();
            // Une las partes restantes
            nombreReturn = partes.join(" ");
            return nombreReturn;
        } else {
            return nombreReturn;
        }

    }



    agruparPorGiro() {
        // Crear un objeto para almacenar los objetos agrupados por desafío
        const objetosAgrupadosPorGiro = {};

        // Iterar a través del arreglo de objetos
        this.marcajes.forEach((objeto) => {

            const giro = objeto.giros;

            // Verificar si el desafío ya está en el objeto de agrupación
            if (objetosAgrupadosPorGiro.hasOwnProperty(giro)) {
                objetosAgrupadosPorGiro[giro].push(objeto);
            } else {
                objetosAgrupadosPorGiro[giro] = [objeto];
            }
        });
        return objetosAgrupadosPorGiro;

    }



    arrayCantidadGiro(key, utilizarConfOrden: boolean) {
        if (this.agruparPorGiro()[key] === undefined) { return []; }


        if (utilizarConfOrden) {
            if (this.ordenPantalla === 'ASC') {
                return this.agruparPorGiro()[key].filter((marcaje) => marcaje.estadoTiempo !== this.DNS).sort((a, b) => {
                    if (a.giros > a.girosCompletados && b.giros <= b.girosCompletados) {
                        return 1; // a va después de b si tiene más giros pendientes
                    }
                    if (a.giros <= a.girosCompletados && b.giros > b.girosCompletados) {
                        return -1; // a va antes de b si tiene menos giros pendientes
                    }
                    if (a.estadoTiempo === this.DNF && b.estadoTiempo !== this.DNF) {
                        return 1; // a va después de b si a es DNF
                    }
                    if (a.estadoTiempo !== this.DNF && b.estadoTiempo === this.DNF) {
                        return -1; // a va antes de b si b es DNF
                    }
                    if (a.estadoTiempo === this.DPP && b.estadoTiempo !== this.DPP) {
                        return 1; // a va después de b si a es DPP
                    }
                    if (a.estadoTiempo !== this.DPP && b.estadoTiempo === this.DPP) {
                        return -1; // a va antes de b si b es DPP
                    }
                    return a.tiempo.localeCompare(b.tiempo); // orden normal
                }).slice(0, this.cantidadPorTabla);

            }

            if (this.ordenPantalla === 'DESC') {
                return this.agruparPorGiro()[key].filter((marcaje) => marcaje.estadoTiempo !== this.DNS).sort((a, b) => b.tiempo.localeCompare(a.tiempo)).slice(0, this.cantidadPorTabla);

            }
        } else {
            return this.agruparPorGiro()[key].filter((marcaje) => marcaje.estadoTiempo !== this.DNS).sort((a, b) => b.tiempo.localeCompare(a.tiempo)).slice(0, this.cantidadPorTabla);

        }
    }


    estaPremiadoGeneral(dor) {
        return this.marcajes.find((marcaje) => marcaje.dor === dor && marcaje.posicion_categoria === 'PREMIADO/A EN GENERAL') !== undefined;
    }

    iteraciones(key) {
        const array = this.arrayCantidadGiro(key, false);
        return Array(this.cantidadPorTabla - array.length).fill(0);

    }

    buscarDor(dor) {
        const busqueda = this.marcajes.find((marcaje) => marcaje.dor === dor);
        if (busqueda === undefined) { return { estadoTiempo: this.DNS }; }
        return busqueda;
    }

    split(array, limit) {
        return array.slice(0, limit);

    }

    encontrarHoraMayor(horas): string {
        let horaMayor: string | null = null;

        for (const hora of horas) {
            if (!horaMayor || hora > horaMayor) {
                horaMayor = hora;
            }
        }

        return horaMayor || ''; // Devuelve la hora mayor o una cadena vacía si el array está vacío
    }

    primerasOcurrencias() {
        // Objeto Set para rastrear las categorías seleccionadas
        let girosSeleccionadas = new Set();

        // Arreglo para almacenar las primeras 4 ocurrencias únicas
        let primerasCuatroOcurrencias = [];

        // Iterar sobre el arreglo 'datos'
        for (let i = 0; i < this.registros.length; i++) {
            let objeto = this.registros[i];
            let giro = objeto.giros;

            // Verificar si la categoría ya ha sido seleccionada
            if (!girosSeleccionadas.has(giro)) {
                // Agregar la categoría al conjunto de categorías seleccionadas
                girosSeleccionadas.add(giro);

                // Agregar el objeto al arreglo de primeras 4 ocurrencias únicas
                primerasCuatroOcurrencias.push(objeto);


            }
        }

        return primerasCuatroOcurrencias;
    }

    inicializarNumeros() {
        for (let i = 0; i <= this.primerasOcurrencias().length - 1; i++) {
            this.numerosDisponibles.push(i);
        }
    }

    obtenerNumeroRandom() {
        if (this.numerosDisponibles.length === 0) {
            // Reiniciar la lista de números disponibles si no quedan más números
            this.inicializarNumeros();
        }

        // Generar un índice aleatorio
        let indiceAleatorio = Math.floor(Math.random() * this.numerosDisponibles.length);
        // Obtener el número en ese índice
        let numero = this.numerosDisponibles.splice(indiceAleatorio, 1)[0];

        return numero;
    }

    marcajeEnRuta(marcajeEstadoTiempo: string) {
        return marcajeEstadoTiempo !== this.DNS && marcajeEstadoTiempo !== this.DNF && marcajeEstadoTiempo !== this.DPP;
    }
}